import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import {
  closeModalSafely,
  handleCreateTableReservation,
  handleTableQuerySubmit,
} from './table-reservation.service';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import {
  FormattedDate,
  FormattedMessage,
  FormattedNumber,
  useIntl,
} from 'react-intl';
import { connect } from 'react-redux';
import FormField from '../../form/fields/FormField';
import { setIsTableReservationModalOpen } from '../../../../redux/modal/modal.actions';
import { fetchStore } from '../../../../redux/store/store.actions';
import {
  Button,
  Col,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
} from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import { fetchOnAuthenticated } from '../../../../redux/me/me.actions';
import { SocketContext } from '../../../../context/socket.context';
import VerificationInput from 'react-verification-input';
import classNames from 'classnames';
import * as Icon from 'react-feather';
import {
  calculateLighterAndDarker,
  replaceColorInLottie,
  roundDate,
  trimText,
} from '../../../../utility/util/util.service';
import classnames from 'classnames';
import moment from 'moment';
import Lottie from 'lottie-react';
import successAnimation from '../../../../assets/lottie/success-1.json';
import errorAnimation from '../../../../assets/lottie/reservation-error.json';
import calendarAnimation from '../../../../assets/lottie/calendar-1.json';
import searchAnimation from '../../../../assets/lottie/search-1.json';
import finishAnimation from '../../../../assets/lottie/success-3.json';

const TableReservationModal = ({
  me,
  store,
  isOpen,

  setIsTableReservationModalOpen,
  fetchOnAuthenticated,
}) => {
  const intl = useIntl();
  const socketContext = useContext(SocketContext);

  const [currentStep, setCurrentStep] = useState(0);
  const [targetReservation, setTargetReservation] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [slots, setSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const updateTargetReservationTimes = (startAt, duration) => {
    const baseMoment = moment(startAt || targetReservation?.startAt);
    const currentMinutes = baseMoment.minute();
    const nearestMultipleOf15 = Math.round(currentMinutes / 15) * 15;
    const deltaMinutes = nearestMultipleOf15 - currentMinutes;
    const startAtMoment = baseMoment
      .add(deltaMinutes, 'minutes')
      .startOf('minute');
    const determinedDuration = duration || targetReservation?.duration || 1.5;

    setTargetReservation({
      ...targetReservation,
      startAt: startAtMoment.toDate(),
      endAt: startAtMoment
        .add(determinedDuration, 'hours')
        .subtract(1, 'millisecond')
        .toDate(),
      duration: determinedDuration,
    });
  };

  // set defaults on open
  useEffect(() => {
    if (isOpen) {
      const in30Minutes = moment()
        .add(30, 'minutes')
        .toDate();
      updateTargetReservationTimes(in30Minutes);
    }
  }, [isOpen]);

  const closeModal = () => {
    setCurrentStep(0);
    setTargetReservation(null);
    setIsTableReservationModalOpen(false);
    setSlots([]);
    setSelectedSlot(null);
  };

  const _closeModalSafely = () => {
    closeModalSafely(isSubmitting, closeModal);
  };

  const handleSubmit = (event, errors, values) =>
    handleTableQuerySubmit(
      event,
      errors,
      values,
      targetReservation,
      setTargetReservation,
      setCurrentStep,
      setSlots,
      setIsSubmitting,
      socketContext.setToken,
      me,
      intl,
      fetchOnAuthenticated,
    );

  const primaryColorVariations =
    store?.primaryColor && calculateLighterAndDarker(store.primaryColor, 0.5);

  const searchLottie = useMemo(
    () => (
      <Lottie
        animationData={replaceColorInLottie(
          searchAnimation,
          store?.primaryColor || '#22442c',
        )}
        loop
      />
    ),
    [store?.primaryColor],
  );

  const calendarLottie = useMemo(
    () => (
      <Lottie
        className="icon"
        animationData={replaceColorInLottie(
          calendarAnimation,
          store?.primaryColor || '#22442c',
          store?.secondaryColor || '#22442c',
          primaryColorVariations?.lighter,
          primaryColorVariations?.darker,
        )}
        loop
      />
    ),
    [store?.primaryColor],
  );

  const errorLottie = useMemo(
    () => (
      <Lottie
        className="icon"
        animationData={replaceColorInLottie(
          errorAnimation,
          store?.primaryColor || '#22442c',
        )}
        loop={false}
      />
    ),
    [store?.primaryColor],
  );

  const successLottie = useMemo(
    () => (
      <Lottie
        className="icon"
        animationData={replaceColorInLottie(
          successAnimation,
          store?.primaryColor || '#22442c',
        )}
        /*rendererSettings={{ viewBoxSize: '150 150 700 700' }}*/
        loop={false}
      />
    ),
    [store?.primaryColor],
  );

  const finishLottie = useMemo(
    () => (
      <Lottie
        style={{}}
        animationData={replaceColorInLottie(
          finishAnimation,
          store?.primaryColor || '#22442c',
        )}
        loop={false}
      />
    ),
    [store?.primaryColor],
  );

  const getKey = (slot) =>
    new Date(slot.startAt).toISOString() + new Date(slot.endAt).toISOString();

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={_closeModalSafely}
      /*title={intl.formatMessage({ id: 'tableReservationLabel' })}*/
    >
      <div className="px-1">
        {currentStep === 0 &&
          (isSubmitting ? (
            <div className="d-flex justify-content-center align-content-center">
              {searchLottie}
            </div>
          ) : (
            <AvForm
              className="pb-1"
              onSubmit={handleSubmit}
              disabled={isSubmitting}
            >
              <div className="modal-header-container">
                {calendarLottie}
                <div className="content">
                  <h1>
                    <FormattedMessage
                      id="tableReservationIntroText"
                      values={{ storeName: store?.name }}
                    />
                  </h1>
                  <span>
                    <FormattedMessage id="tableReservationIntroSubText" />
                  </span>
                </div>
              </div>
              <AvInput name="storeId" value={store?.id} hidden />
              <Row>
                <Col xs={6} className="pr-50">
                  <FormField
                    propertyName="name"
                    messageId="tableReservationForLabel"
                    object={targetReservation}
                    required
                  />
                </Col>
                <Col xs={6} className="pl-50">
                  <FormField
                    type="number"
                    propertyName="personsQty"
                    messageId="personsQtyLabel"
                    object={targetReservation}
                    valueParser={(value) => {
                      const regex = /^[0-9]+$/;
                      if (regex.test(value)) {
                        const parsedValue = parseInt(value);
                        return parsedValue >= 2 ? parsedValue : {}; // {} is definitely not a number
                      } else {
                        return {}; // {} is definitely not a number
                      }
                    }}
                    required
                  />
                </Col>
              </Row>
              <AvGroup className="form-label-group mb-0">
                <Flatpickr
                  id="startAt"
                  className="form-control bg-white text-center"
                  value={targetReservation?.startAt}
                  options={{
                    enableTime: true,
                    noCalendar: false,
                    minDate: new Date(),
                    minuteIncrement: 15,
                  }}
                  onChange={([date]) => updateTargetReservationTimes(date)}
                />
                <Label className="floating-label" for="startAt">
                  <FormattedMessage id="tableReservationStartingAt" />
                </Label>
              </AvGroup>
              <Label className="default-field-label">
                <FormattedMessage id="tableReservationDurationLabel" />
              </Label>
              <Nav pills className="nav-fill pill-bar mb-2">
                {[1, 1.5, 2].map((hours, index) => (
                  <NavItem key={index}>
                    <NavLink
                      className={classnames({
                        active: targetReservation?.duration === hours,
                      })}
                      onClick={() => updateTargetReservationTimes(null, hours)}
                    >
                      <FormattedNumber value={hours} format="hours" />
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
              <SaveSubmitButton
                messageId="nextStep"
                isSubmitting={isSubmitting}
              />
            </AvForm>
          ))}

        {currentStep === 1 && (
          <>
            <div className="modal-header-container">
              {errorLottie}

              <div className="content">
                <h1>
                  <FormattedMessage id="selectReservationSlotHeading" />
                </h1>
                <span>
                  <FormattedMessage id="selectReservationSlotSubHeading" />
                </span>
              </div>
            </div>
            {slots?.map((slot, index) => {
              const key = getKey(slot);
              const descriptor =
                intl.formatTime(slot.startAt) +
                ' - ' +
                intl.formatTime(roundDate(slot.endAt));

              return (
                <div
                  key={index}
                  style={{ transition: 'border 300ms', height: '50px' }}
                  className={classNames(
                    'd-flex justify-content-between align-items-center my-50 p-75 border rounded',
                    {
                      'border-primary':
                        selectedSlot && key === getKey(selectedSlot),
                    },
                  )}
                  onClick={() => {
                    setSelectedSlot(slot);
                    setTargetReservation({
                      ...targetReservation,
                      startAt: slot.startAt,
                      endAt: slot.endAt,
                      tables: slot.tables,
                    });
                  }}
                >
                  <div>
                    {selectedSlot && key === getKey(selectedSlot) ? (
                      <Icon.CheckSquare
                        className="vx-icon mr-1 primary"
                        size={24}
                      />
                    ) : (
                      <Icon.Square className="vx-icon mr-1" size={24} />
                    )}
                    <span>{trimText(descriptor, 40)}</span>
                  </div>
                </div>
              );
            })}
          </>
        )}

        {currentStep === 2 && (
          <>
            <div className="modal-header-container">
              {successLottie}

              <div style={{ maxWidth: '385px' }} className="content">
                <h1>
                  <FormattedMessage id="tableReservationTableFoundTitle" />
                </h1>
              </div>
            </div>
            <div className="py-1">
              {[
                {
                  id: 'tableReservationForLabel',
                  content: targetReservation?.name,
                },
                {
                  id: 'personsQtyLabel',
                  content: targetReservation?.personsQty,
                },
                {
                  id: 'tableReservationStartsAtLabel',
                  content: (
                    <FormattedDate
                      value={roundDate(targetReservation?.startAt)}
                      format="full2Digit"
                    />
                  ),
                },
                {
                  id: 'tableReservationEndsAtLabel',
                  content: (
                    <FormattedDate
                      value={roundDate(targetReservation?.endAt)}
                      format="full2Digit"
                    />
                  ),
                },
              ].map(({ id, content }, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center"
                >
                  <span>
                    <FormattedMessage id={id} />
                  </span>
                  <span
                    className="d-inline-block text-truncate"
                    style={{ maxWidth: '60%' }}
                  >
                    {content}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}

        {currentStep === 3 && (
          <>
            <h1 className="font-medium-3 m-0 text-center">
              <FormattedMessage id="tableReservationAccessCodeTitle" />
            </h1>
            <VerificationInput
              classNames={{
                container: 'container my-2 verificationInput',
                character: 'border rounded primary',
                characterInactive: '',
                characterSelected: 'outline-none border-primary',
              }}
              length={4}
              validChars="0-9"
              inputProps={{ inputMode: 'numeric' }}
              placeholder=""
              onComplete={(value) => {
                setTargetReservation({
                  ...targetReservation,
                  accessCode: value,
                });
              }}
            />
            <span className="d-block text-center font-small-3 mt-2">
              <FormattedMessage
                id="tableReservationAccessCodeLabel"
                values={{ storeName: store?.name }}
              />
            </span>
          </>
        )}

        {currentStep === 4 && (
          <div className="d-flex flex-column justify-content-center align-items-center">
            {finishLottie}

            <h1 className="font-medium-1 m-0">
              <FormattedMessage id="successReservationAnimationTitle" />
            </h1>
            <span className="d-block font-small-3">
              <FormattedMessage id="successReservationAnimationSubTitle" />
            </span>
          </div>
        )}

        {currentStep > 0 && currentStep < 4 && (
          <div className="align-content-center d-flex m-auto">
            <Button
              color="primary"
              className="w-100 mt-2"
              onClick={(e) => {
                e.preventDefault();

                switch (currentStep) {
                  case 1:
                  case 2:
                    setCurrentStep(3);
                    break;
                  case 3:
                    handleCreateTableReservation(
                      targetReservation,
                      setTargetReservation,
                      setIsSubmitting,
                      closeModal,
                      () => {
                        setCurrentStep(4);
                        setTimeout(closeModal, 5000);
                      },
                    );
                }
              }}
            >
              {isSubmitting ? (
                <>
                  <Spinner color="white" size="sm" />
                  <span className="ml-50">
                    <FormattedMessage id="loading" />
                  </span>
                </>
              ) : (
                <FormattedMessage id="nextStep" />
              )}
            </Button>
          </div>
        )}
      </div>
    </ModalSheet>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isTableReservationModalOpen,
  me: state.me.me,
  store: state.store.store,
});

export default connect(mapStateToProps, {
  setIsTableReservationModalOpen,
  fetchStore,
  fetchOnAuthenticated,
})(TableReservationModal);
